"use client";

import { LEAD_CAPTURE_MODAL_ACTION, openLeadCaptureModal } from "~/common/lib/leadCaptureModal";

export default function ChatbotActionButton({ action = "postText", actionArgs = [], onClick, ...rest }) {
  const handleClick = (event) => {
    onClick?.(event);
    if (event?.defaultPrevented) return;

    if (action === LEAD_CAPTURE_MODAL_ACTION) {
      openLeadCaptureModal(actionArgs[0]);
      return;
    }

    const actionFn = window.palActions?.[action];
    if (typeof actionFn === "function") {
      actionFn(...actionArgs);
    }
  };

  return <button {...rest} onClick={handleClick} />;
}
